import React from 'react';
import loadable from '@loadable/component';
import { Route, Routes, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Loader } from '../../../../common/components';
// Routes
const ListSkillPage = loadable(() => import('./ListSkillPage'), {
  fallback: <Loader />
});
const AddSkillPage = loadable(() => import('./AddSkillPage'), {
  fallback: <Loader />
});
const EditSkillPage = loadable(() => import('./EditSkillPage'), {
  fallback: <Loader />
});
const InterviewStatusRoute = ({ t, alert }) => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListSkillPage t={t} alert={alert} />} />
      <Route exact path="/add" element={<AddSkillPage t={t} alert={alert} />} />
      <Route exact path="/edit/:id" element={<EditSkillPage t={t} alert={alert} />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};
InterviewStatusRoute.propTypes = {
  t: PropTypes.func
};
export default InterviewStatusRoute;
